var exports = {
  "WB": "GroupDMWelcomeSection.module__welcomeSection___a1RwM2",
  "rZ": "GroupDMWelcomeSection.module__profileSection___a1RwM2",
  "hv": "GroupDMWelcomeSection.module__groupName___a1RwM2",
  "Yh": "GroupDMWelcomeSection.module__welcomeText___a1RwM2",
  "o1": "GroupDMWelcomeSection.module__actions___a1RwM2",
};

module.exports = exports;
